var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{ref:"dragContent",staticClass:"cont"},[_c('div',{staticClass:"mask",on:{"click":_vm.shut}}),_c('ul',{staticClass:"keyboard",on:{"mousedown":function($event){return _vm.tagDraggable($event)}}},_vm._l((_vm.keyList),function(key,index){return _c('li',{key:index,class:{
        delete: key === 'Delete',
        tab: key === 'Tab',
        capslock: key === 'Caps',
        enter: key === 'Enter',
        shift: key === 'Shift',
        space: key === 'Space',
        shifted: key === 'Shift' && _vm.hasShifted,
        capsed: key === 'Caps' && _vm.hasCapsed,
      },attrs:{"track-by":"$index"},domProps:{"textContent":_vm._s(key)},on:{"click":function($event){return _vm.clickKey(key)}}})}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }